import { AbilityBuilder } from "@casl/ability";

export default AbilityBuilder.define((can) => {
  if (localStorage.getItem("printable_admin_roles")) {
    const permissions = JSON.parse(
      localStorage.getItem("printable_admin_roles")
    );
    console.log(permissions);
    permissions.forEach((permission) => {
      if (permission.action !== null && permission.subject !== null) {
        can(permission.action, permission.subject);
      }
    });
  }
});
